// Mock data for Amal's Portfolio

export const profileData = {
  name: "AMAL PS",
  title: "Junior Software Engineer",
  location: "Attingal, Thiruvananthapuram, Kerala, India",
  phone: "8111980533",
  email: "amalps.dev@gmail.com",
  linkedin: "https://linkedin.com/in/amal-ps-938088336",
  summary: "As a dedicated software engineer, I aim to leverage my technical expertise and creative problem-solving skills to design and develop innovative, scalable, and secure software solutions that address real-world challenges. I am passionate about building user-centric applications that deliver exceptional experiences, and I seek to contribute to a dynamic team focused on driving technological advancement, improving efficiency, and fostering innovation.",
  languages: ["Malayalam", "English", "Tamil"],
  interests: ["Learning new technology", "Music", "Travelling"]
};

export const skills = [
  { name: "Laravel", level: 90, category: "Backend" },
  { name: "React JS", level: 85, category: "Frontend" },
  { name: "MySQL", level: 80, category: "Database" },
  { name: "PHP", level: 85, category: "Backend" },
  { name: "JavaScript", level: 80, category: "Frontend" },
  { name: "Redux", level: 75, category: "Frontend" },
  { name: "HTML & CSS", level: 90, category: "Frontend" },
  { name: "Tiptap", level: 70, category: "Tools" }
];

export const experiences = [
  {
    id: 1,
    company: "RSGP Consulting Private Limited",
    position: "Software Engineer",
    startDate: "Sep 2025",
    endDate: "Present",
    current: true,
    responsibilities: [
      "Collaboratively designed and developed a web-based document editor similar to Google Docs",
      "Focused on structured XML conversion for document processing",
      "Implemented key features including version history management and document templates",
      "Developed offline functionality for seamless user experience",
      "Utilized React.js, Laravel, Tiptap, and MySQL for full-stack development"
    ]
  },
  {
    id: 2,
    company: "KELTRON",
    position: "Intern",
    startDate: "2022",
    endDate: "2022",
    current: false,
    responsibilities: [
      "Gained hands-on experience in software development",
      "Worked on various technical projects and assignments"
    ]
  },
  {
    id: 3,
    company: "Trinity Technologies",
    position: "Intern",
    startDate: "2021",
    endDate: "2021",
    current: false,
    responsibilities: [
      "Participated in software development lifecycle",
      "Contributed to team projects and learned industry best practices"
    ]
  }
];

export const projects = [
  {
    id: 1,
    title: "Web-Based Document Editor",
    description: "A collaborative document editing platform similar to Google Docs, featuring real-time editing, version control, and structured XML conversion.",
    technologies: ["React.js", "Laravel", "Tiptap", "MySQL", "Redux"],
    features: [
      "Real-time collaborative editing",
      "Version history management",
      "Document templates",
      "Offline functionality",
      "Structured XML conversion",
      "User authentication and authorization"
    ],
    status: "In Production",
    role: "Full-Stack Developer"
  }
];

export const education = [
  {
    id: 1,
    degree: "Computer Hardware Engineering",
    institution: "Government Polytechnic College, Attingal",
    startDate: "2018",
    endDate: "2020",
    description: "Specialized in computer hardware engineering with focus on system architecture and programming fundamentals."
  },
  {
    id: 2,
    degree: "Higher Secondary School",
    institution: "GHSS Kavalayoor",
    startDate: "2015",
    endDate: "2017",
    description: "Completed higher secondary education with focus on science stream."
  }
];
